import { render } from "./ProfileDetail.vue?vue&type=template&id=03a0d704&scoped=true"
import script from "./ProfileDetail.vue?vue&type=script&lang=js"
export * from "./ProfileDetail.vue?vue&type=script&lang=js"

import "./ProfileDetail.vue?vue&type=style&index=0&id=03a0d704&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a0d704"]])

export default __exports__